import React from 'react';
import { about } from '../../portfolio';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const Gallery = () => {
  return (
    <>
      <section className="section">
        <div className="section-header">
          <h1 className="section-title">Gallery</h1>
          <p className="section-subtitle">Some of my picture so that you can view me from few angles.</p>
        </div>
        <div className="photo-grid">
          <div className="photo-item"><img src="/images/roshanimage1.jpg" alt="Roshan 1" /></div>
          <div className="photo-item"><img src="/images/roshanimage2.jpg" alt="Roshan 2" /></div>
          <div className="photo-item"><img src="/images/roshanimage3.jpg" alt="Roshan 3" /></div>
          <div className="photo-item"><img src="/images/roshanimage4.jpg" alt="Roshan 4" /></div>
          <div className="photo-item"><img src="/images/roshanimage5.jpg" alt="Roshan 5" /></div>
        </div>
      </section>
      
      <footer className="footer">
        <div className="footer-socials">
          {about.social.tweet && <a href={about.social.tweet}><TwitterIcon style={{ fontSize: 20 }} /></a>}
          {about.social.github && <a href={about.social.github}><GitHubIcon style={{ fontSize: 20 }} /></a>}
          {about.social.linkedin && <a href={about.social.linkedin}><LinkedInIcon style={{ fontSize: 20 }} /></a>}
        </div>
        <div>End of line.</div>
      </footer>
    </>
  );
};

export default Gallery;
